import { render } from "./BillingOverdueNotificationContainer.vue?vue&type=template&id=0624552e"
import script from "./BillingOverdueNotificationContainer.vue?vue&type=script&lang=js"
export * from "./BillingOverdueNotificationContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__